module.exports = __webpack_public_path__ + "img/ic_google-pay_payment-method.ffd6b4b.svg";